// Companies prospected area - Google Places integration with SlimSelect

function googleMapsReady() {
  return typeof google !== 'undefined' && google.maps?.places
}

function initCompaniesProspectedAreaPage() {
  const searchInput = document.querySelector('#prospected_area_search')
  if (!searchInput || !window.SlimSelect || searchInput._slimSelect) return

  const form = searchInput.closest('form')
  if (!form) return

  const field = (name) => form.querySelector(`[name$="[${name}]"]`)

  const countryCodeInput = field('country_code')
  const regionInput = field('region')
  const departmentInput = field('department')
  const departmentNumberInput = field('department_number')
  const cityInput = field('city')
  const radiusInput = field('radius')
  const longitudeInput = field('longitude')
  const latitudeInput = field('latitude')
  const zipCodeInput = field('zip_code')

  async function mapPredictionsToSlimSelectOptions(predictions, status) {
    const options = []
    if (status === google.maps.places.PlacesServiceStatus.OK && predictions != null) {
      const promises = predictions.map((prediction) => {
        return fetchPlaceDetails(prediction.place_id)
          .then((zipCode) => {
            const city = prediction.structured_formatting.main_text
            const country = prediction.structured_formatting.secondary_text
            const label = [city, zipCode, country].filter((item) => item).join(', ')
            return {
              value: prediction.place_id,
              text: label,
            }
          })
          .catch((error) => {
            console.error('Error fetching zip code:', error)
            return {
              value: prediction.place_id,
              text: prediction.description,
            }
          })
      })

      try {
        const results = await Promise.all(promises)
        options.push(...results)
      } catch (error) {
        console.error('Error fetching results:', error)
      }
    }
    return options
  }

  function fetchPlaceDetails(placeId) {
    return new Promise(function(resolve, reject) {
      const service = new google.maps.places.PlacesService(document.createElement('div'))
      service.getDetails({ placeId: placeId }, function(place, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          const details = []
          for (let i = 0; i < place.address_components.length; i++) {
            if (place.address_components[i].types[0] === 'postal_code') {
              details.push(place.address_components[i].long_name)
            }
            if (place.address_components[i].types[0] === 'administrative_area_level_2') {
              details.push(place.address_components[i].long_name)
            }
          }
          resolve(details.join(', '))
        } else {
          reject(status)
        }
      })
    })
  }

  function getPredictionCountries() {
    return countryCodeInput ? countryCodeInput.value : ''
  }

  function setHiddenInputValues(selectedProspectedArea) {
    if (regionInput) regionInput.value = selectedProspectedArea.region || ''
    if (departmentInput) departmentInput.value = selectedProspectedArea.department || ''
    if (departmentNumberInput) departmentNumberInput.value = selectedProspectedArea.departmentNumber || ''
    if (cityInput) cityInput.value = selectedProspectedArea.city || ''
    if (longitudeInput) longitudeInput.value = selectedProspectedArea.lng ?? ''
    if (latitudeInput) latitudeInput.value = selectedProspectedArea.lat ?? ''
    if (zipCodeInput) zipCodeInput.value = selectedProspectedArea.zipCode || ''
    if (radiusInput && selectedProspectedArea.radius) radiusInput.value = selectedProspectedArea.radius

    if (countryCodeInput && selectedProspectedArea.countryCode) {
      countryCodeInput.value = selectedProspectedArea.countryCode
      countryCodeInput.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  function extractSelectedProspectedArea(placeId) {
    new google.maps.Geocoder().geocode({ placeId: placeId }, function(results, status) {
      if (results && results.length > 0) {
        setHiddenInputValues(extractProspectedAreaComponents(results[0]))
      }
    })
  }

  // Duplicate from frontend company-lead-prospected-area.component.ts
  function extractProspectedAreaComponents(place) {
    let radius = radiusInput ? radiusInput.value : ''
    if (!radius && radiusInput) {
      radiusInput.value = '100'
      radiusInput.dispatchEvent(new Event('change', { bubbles: true }))
      radius = '100'
    }

    const find = window._ ? window._.find : (array, predicate) => array.find(predicate)

    const countryComponent = find(place.address_components, (o) => o.types.includes('country'))
    const countryCode = countryComponent?.short_name

    const cityComponent = find(place.address_components, (o) => o.types.includes('locality'))
    const city = cityComponent?.long_name

    const postalCodeComponent = find(place.address_components, (o) => o.types.includes('postal_code'))
    let zipCode = postalCodeComponent?.long_name
    if (!zipCode && countryCodeInput && ['CN', 'HK'].includes(countryCodeInput.value)) {
      zipCode = '999077'
    }

    const departmentComponent = find(place.address_components, (o) =>
      o.types.includes('administrative_area_level_2')
    )
    let department
    if (departmentComponent) {
      department = departmentComponent.long_name
        .replace('Département de ', '')
        .replace('Département ', '')
        .replace('Departement ', '')
        .replace("'", "'")
    }

    const regionComponent = find(place.address_components, (o) =>
      o.types.includes('administrative_area_level_1')
    )
    const region = regionComponent?.long_name

    const lat = place.geometry.location.lat()
    const lng = place.geometry.location.lng()

    return { zipCode, city, department, region, lat, lng, radius, countryCode }
  }

  function placePredictionRequest(search, resolve, reject) {
    if (!googleMapsReady()) {
      reject('Google Maps n\'est pas encore chargé, veuillez réessayer dans quelques secondes')
      return
    }

    const request = {
      input: search,
      types: ['(cities)'],
    }

    const country = getPredictionCountries()
    if (country) {
      request.componentRestrictions = { country }
    }

    const service = new google.maps.places.AutocompleteService()
    service.getPlacePredictions(request, async function(predictions, status) {
      try {
        const options = await mapPredictionsToSlimSelectOptions(predictions, status)
        resolve(options)
      } catch (error) {
        console.error('Error fetching predictions:', error)
        reject('Erreur lors de la recherche')
      }
    })
  }

  const slimSelect = new window.SlimSelect({
    select: searchInput,
    settings: {
      placeholder: 'Tapez pour rechercher une ville...',
      allowDeselect: true,
      searchPlaceholder: 'Tapez pour rechercher...',
      searchText: 'Aucun résultat',
      searchingText: 'Recherche...',
    },
    events: {
      search: (search) => {
        return new Promise((resolve, reject) => {
          if (search.length < 3) {
            reject('Veuillez entrer au moins 3 caractères')
            return
          }

          placePredictionRequest(search, resolve, reject)
        })
      },
      afterChange: (newVal) => {
        searchInput.dispatchEvent(new Event('change', { bubbles: true }))

        if (!newVal || newVal.length === 0) {
          setHiddenInputValues({})
          return
        }

        const selectedOption = newVal[0]
        const placeId = typeof selectedOption === 'string' ? selectedOption : selectedOption.value

        if (placeId) {
          extractSelectedProspectedArea(placeId)
        }
      },
    },
  })

  searchInput._slimSelect = slimSelect

  form.addEventListener('submit', (event) => {
    if (!latitudeInput?.value || !longitudeInput?.value || !cityInput?.value) {
      event.preventDefault()
      window.alert('Veuillez sélectionner une ville dans la liste de suggestions avant de valider.')
    }
  })
}

window.initProspectedAreaGoogleMaps = initCompaniesProspectedAreaPage

document.addEventListener('DOMContentLoaded', () => {
  initCompaniesProspectedAreaPage()
  // Fallback when Google Maps callback is not used or loads slowly
  setTimeout(initCompaniesProspectedAreaPage, 500)
  setTimeout(initCompaniesProspectedAreaPage, 2000)
})
